import Vue from 'vue';

import {
  Button,
  Field,
  Dialog,
  Tag,
  Image,
  Overlay,
  Popup,
  Picker,
  NoticeBar,
  List,
  TreeSelect,
  Search,
  Toast,
  Sticky,
  DropdownItem,
  DropdownMenu,
  Cell,
  SwipeItem,
  Swipe,
  Grid,
  GridItem,
  Tabbar,
  TabbarItem,
  Tabs,
  Tab,
  Icon,
  PullRefresh,
  Empty,
  Form,
  CellGroup,
  RadioGroup,
  Radio,
  Switch,
  Uploader,
  DatetimePicker,
  ImagePreview,
  Loading,
  Checkbox,
  Slider
} from '@zyf2e/capui-mobile';

Vue.use(Button)
  .use(Field)
  .use(Tag)
  .use(Image)
  .use(Overlay)
  .use(Popup)
  .use(Picker)
  .use(NoticeBar)
  .use(List)
  .use(TreeSelect)
  .use(Search)
  .use(Dialog)
  .use(Toast)
  .use(Sticky)
  .use(DropdownMenu)
  .use(DropdownItem)
  .use(Cell)
  .use(Swipe)
  .use(SwipeItem)
  .use(Grid)
  .use(GridItem)
  .use(Tabbar)
  .use(TabbarItem)
  .use(PullRefresh)
  .use(Tab)
  .use(CellGroup)
  .use(Tabs)
  .use(Icon)
  .use(Empty)
  .use(Form)
  .use(CellGroup)
  .use(RadioGroup)
  .use(Radio)
  .use(Switch)
  .use(Uploader)
  .use(DatetimePicker)
  .use(ImagePreview)
  .use(Loading)
  .use(Checkbox)
  .use(Slider);
